import { render, staticRenderFns } from "./areaSystem.vue?vue&type=template&id=010b3769&scoped=true&"
import script from "./areaSystem.vue?vue&type=script&lang=js&"
export * from "./areaSystem.vue?vue&type=script&lang=js&"
import style0 from "./areaSystem.vue?vue&type=style&index=0&id=010b3769&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b3769",
  null
  
)

export default component.exports